import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setDetailProduct } from 'slices/store'
import { INTERNAL_REDIRECT_TYPE } from 'app-constants'
import { fetchBanners } from 'slices/banners'
import { CarouselNew } from 'components'
import { CarouselArrowBanner } from 'components/drawer/templates/store/components'
import { getInternalRedirect, handleInternalRedirect, isExternalUrl } from 'utils'
import './style.scss'

export function BannersCarousel() {
  const {
    selected: { id: contractId },
  } = useSelector(({ contract }) => contract)
  const { banners, isLoading } = useSelector(state => state.banners)
  const { isEligibleToBuy } = useSelector(state => state.store)
  const dispatch = useDispatch()
  const { push } = useHistory()

  useEffect(() => {
    dispatch(fetchBanners(contractId))
  }, [contractId, dispatch])

  function getInternalRedirectPush(internalRedirect) {
    const { TYPE: type, TO: to } = internalRedirect
    const isRouteType = INTERNAL_REDIRECT_TYPE.ROUTE === type
    const shouldCreatePush = isRouteType && !!to

    if (shouldCreatePush) push(to)
  }

  function handleRedirect(internalRedirect, product, isSoftbundle) {
    const redirect = handleInternalRedirect(
      internalRedirect,
      getInternalRedirectPush(internalRedirect)
    )

    if (redirect) {
      if (isSoftbundle) dispatch(setDetailProduct(product))

      dispatch(redirect)
    }
  }

  function getBannersToShow() {
    if (isEligibleToBuy) return banners

    return banners.filter(({ isSoftbundle }) => !isSoftbundle)
  }

  function renderBannerImg(image) {
    return <img src={image} alt='Banner' className='banner-image' />
  }

  function renderBannerLink(image, redirect) {
    return (
      <a href={redirect} target='_blank' rel='noreferrer'>
        {renderBannerImg(image)}
      </a>
    )
  }

  function renderInternalRedirectBanner(image, internalRedirect, product, isSoftbundle) {
    return (
      <button type='button' onClick={() => handleRedirect(internalRedirect, product, isSoftbundle)}>
        {renderBannerImg(image)}
      </button>
    )
  }

  function renderBanner(banner) {
    const { image, redirect, product, isSoftbundle } = banner

    if (isExternalUrl(redirect)) return renderBannerLink(image, redirect)

    const internalRedirect = getInternalRedirect(redirect)
    if (internalRedirect)
      return renderInternalRedirectBanner(image, internalRedirect, product, isSoftbundle)

    return renderBannerImg(image, internalRedirect)
  }

  function renderBanners() {
    if (isLoading) return <div className='loading-banner' />

    const bannersToShow = getBannersToShow()

    return (
      <div className='banner-carousel'>
        <CarouselNew customArrowComponent={CarouselArrowBanner} itemsPerView={1}>
          {bannersToShow.map((banner, index) => (
            <div key={index}>{renderBanner(banner)}</div>
          ))}
        </CarouselNew>
      </div>
    )
  }

  function renderContent() {
    const hasBanners = banners.length > 0

    if (!hasBanners && !isLoading) return null

    return (
      <div className='banner-section'>
        <div className='banner-intro'>
          <h2 className='banner-title'>Ofertas para você</h2>
          <p className='banner-text'>
            Conheça as opções que podem deixar sua experiência ainda mais completa!
          </p>
        </div>
        <div className='banner-container'>{renderBanners()}</div>
      </div>
    )
  }

  return renderContent()
}
